import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.businessActivity.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.businessActivity.saving',
        defaultMessage: 'Saving...'
    },
    businessActivity: {
        id: 'ml.policychange.businessActivity.Business Activity',
        defaultMessage: 'Business Activity'
    },
    nextBaseDescription: {
        id: 'ml.policychange.businessActivity.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.businessActivity.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    addBusinessActivity: {
        id: 'ml.policychange.businessActivity.Add a business activity',
        defaultMessage: 'Add a business activity'
    },
    editBusinessActivity: {
        id: 'ml.policychange.businessActivity.Edit a business activity',
        defaultMessage: 'Edit a business activity'
    },
    underlyingPolicyNotListed: {
        id: 'ml.policychange.businessActivity.Policy is not listed',
        defaultMessage: 'Policy is not listed'
    },
    addAPolicy: {
        id: 'ml.policychange.businessActivity.Add a Policy',
        defaultMessage: 'Add a Policy'
    },
    addPolicy: {
        id: 'ml.policychange.businessActivity.Add Policy',
        defaultMessage: 'Add Policy'
    },
    cancel: {
        id: 'ml.policychange.businessActivity.cancel',
        defaultMessage: 'Cancel'
    },
    addBusinessActivityDynamic: {
        id: 'ml.policychange.businessActivity.Add Business Activity',
        defaultMessage: 'Add Business Activity'
    },
    editBusinessActivityDynamic: {
        id: 'ml.policychange.businessActivity.Edit Business Activity',
        defaultMessage: 'Edit Business Activity'
    },
    businessActivityXHasBeenAdded: {
        id: 'ml.policychange.businessActivity.Business Activity x has been added',
        defaultMessage: 'Business Activity {strongName} has been added.'
    },
    
});
